import { Stack } from '@mui/material';

import { SkeletonBox } from '../_user-tab/styled';

export const SkeletonCard = () => {
  return (
    <Stack flexDirection="column" p="16px" bgcolor="#222833" borderRadius="16px" gap="24px">
      <SkeletonBox animation="wave" height={360} sx={{ borderRadius: '12px' }} />
      <Stack flexDirection="column" gap="12px">
        <Stack gap="12px">
          <SkeletonBox animation="wave" height={28} width={72} />
          <SkeletonBox animation="wave" height={28} width={72} />
        </Stack>
        <SkeletonBox animation="wave" height={26} width={148} />
        <SkeletonBox animation="wave" height={21} width={148} />
        <SkeletonBox animation="wave" height={1} sx={{ borderRadius: '0px' }} />
        {Array.from({ length: 3 }).map((_, i) => (
          <Stack key={i} justifyContent="space-between">
            <SkeletonBox animation="wave" height={24} width={72} />
            <SkeletonBox animation="wave" height={24} width={72} />
          </Stack>
        ))}
        <SkeletonBox animation="wave" height={1} sx={{ borderRadius: '0px' }} />
        <SkeletonBox animation="wave" height={21} width={208} />
      </Stack>
      <Stack flexDirection="column" gap="8px">
        <SkeletonBox animation="wave" height={40} />
        <SkeletonBox animation="wave" height={40} />
      </Stack>
    </Stack>
  );
};
